import CompaniesForm from 'src/javascripts/components/forms/CompaniesForm';

export default class CompaniesNew {

  constructor() {}

  render() {

    // Call associated form js
    CompaniesForm();

  }

}